import {
  TouchpointDTOBatchJobExecutionStatus,
  TouchpointDTOBatchJobType,
  type TouchpointDTOBatchJobExecutionStatus as SyncStatusType,
} from "generated/schemas";

import { type ChipProps } from "ui/chip";

type SyncBadgeConfig = {
  /** `violet` was the email-writer colour until the design system dropped that family. */
  color: Extract<ChipProps["color"], "error" | "default" | "info">;
  label: string;
  jobType: TouchpointDTOBatchJobType;
};

const SYNC_STATUS_BADGE: Record<
  TouchpointDTOBatchJobType,
  Partial<Record<SyncStatusType, Omit<SyncBadgeConfig, "jobType">>>
> = {
  [TouchpointDTOBatchJobType.MONDAY]: {
    [TouchpointDTOBatchJobExecutionStatus.FAILED]: { color: "error", label: "Sync failed" },
    [TouchpointDTOBatchJobExecutionStatus.RUNNING]: { color: "default", label: "Syncing..." },
  },
  [TouchpointDTOBatchJobType.WRITING]: {
    [TouchpointDTOBatchJobExecutionStatus.FAILED]: { color: "error", label: "Writing failed" },
    [TouchpointDTOBatchJobExecutionStatus.RUNNING]: { color: "info", label: "Writing..." },
  },
};

export const getSyncBadgeConfig = (
  status: SyncStatusType | undefined,
  // Rows whose job predates the job-type column were never backfilled; all of those were Monday.
  jobType: TouchpointDTOBatchJobType = TouchpointDTOBatchJobType.MONDAY,
): SyncBadgeConfig | null => {
  const badge = status ? SYNC_STATUS_BADGE[jobType][status] : undefined;

  return badge ? { ...badge, jobType } : null;
};
